import "./number-callout.scss";
